var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paycools-kyc-page" }, [
    _c(
      "section",
      { staticClass: "kyc-content" },
      [
        _c(
          "header",
          { staticClass: "kyc-header" },
          [
            _c(
              "el-button",
              {
                staticStyle: { padding: "0" },
                attrs: { type: "text" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("requestBack")
                  },
                },
              },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "back",
                    "class-name": "kyc-back-icon",
                  },
                }),
              ],
              1
            ),
            _c("h2", { staticClass: "kyc-title" }, [
              _vm._v(_vm._s(_vm.$t("kyc.title"))),
            ]),
          ],
          1
        ),
        _c(
          "el-form",
          {
            ref: "accountForm",
            staticClass: "kyc-form",
            attrs: {
              model: _vm.form,
              rules: _vm.accountRules,
              "label-position": "left",
              "label-width": "260px",
            },
          },
          [
            _vm.rejectionItems && _vm.rejectionItems.length
              ? _c(
                  "div",
                  {
                    staticClass: "kyc-rejection-box",
                    staticStyle: { "margin-bottom": "16px" },
                  },
                  [
                    _c(
                      "el-alert",
                      {
                        attrs: {
                          type: "error",
                          title: _vm.$t("kyc.rejection_title"),
                          closable: false,
                          "show-icon": "",
                        },
                      },
                      _vm._l(_vm.rejectionItems, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "rejection-item" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(index + 1) +
                                ". " +
                                _vm._s(item) +
                                " "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "bank_name",
                  label: _vm.$t("kyc.account_info_bank_name"),
                },
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: _vm.$t(
                        "kyc.account_info_placeholder_bank_name"
                      ),
                      filterable: "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.bank_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bank_name", $$v)
                      },
                      expression: "form.bank_name",
                    },
                  },
                  _vm._l(_vm.bankOptions, function (item) {
                    return _c("el-option", {
                      key: item.bank_code,
                      attrs: {
                        label: item.bank_code + "-" + item.full_name,
                        value: item.bank_code,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "bank_account_name",
                  label: _vm.$t("kyc.account_info_account_name"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t(
                      "kyc.account_info_placeholder_account_name"
                    ),
                    maxlength: "100",
                  },
                  model: {
                    value: _vm.form.bank_account_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "bank_account_name", $$v)
                    },
                    expression: "form.bank_account_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "bank_account_no",
                  label: _vm.$t("kyc.account_info_account_number"),
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t(
                      "kyc.account_info_placeholder_account_number"
                    ),
                    maxlength: "100",
                  },
                  model: {
                    value: _vm.form.bank_account_no,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "bank_account_no", $$v)
                    },
                    expression: "form.bank_account_no",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "form-item-no-style",
                attrs: {
                  prop: "bank_card_files",
                  label: _vm.$t("kyc.account_info_account_proof"),
                },
              },
              [
                _c("UpdateFile", {
                  ref: "bank_card_files",
                  attrs: {
                    type: "bank_card_files",
                    "file-list": _vm.fileList,
                    uploading: _vm.uploading,
                    "remove-files": _vm.removeFiles,
                    "uploading-progress": _vm.uploadingProgress,
                  },
                  on: {
                    changeFileList: _vm.changeFileList,
                    changeUploading: _vm.changeUploading,
                    changeUploadingProgress: _vm.changeUploadingProgress,
                    changeRemoveFiles: _vm.changeRemoveFiles,
                  },
                  model: {
                    value: _vm.form.bank_card_files,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "bank_card_files", $$v)
                    },
                    expression: "form.bank_card_files",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "kyc-footer" },
          [
            _c(
              "el-button",
              {
                staticClass: "kyc-draft-btn",
                attrs: { disabled: _vm.isSubmitting },
                on: { click: _vm.handleSave },
              },
              [_vm._v(_vm._s(_vm.$t("kyc.save_as_draft")))]
            ),
            _c(
              "el-button",
              {
                staticClass: "kyc-submit-btn",
                attrs: { type: "primary", disabled: _vm.isSubmitting },
                on: { click: _vm.handleSubmit },
              },
              [_vm._v(_vm._s(_vm.$t("kyc.submit_application")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }